/**
 * CMOE feature flags — public operator surface:
 * - REACT_APP_CMOE_ENABLED
 * - REACT_APP_CMOE_ORCHESTRATION_MODE (legacy | dual | primary)
 *
 * Sub-capabilities (activity, projections, allocation, command API) derive from
 * orchestration mode after Phase 5. Shadow validation remains an optional ops flag.
 * @see docs/ARCHITECTURE/PHASE5_LEGACY_RETIREMENT.md
 */

import {
  isCmoeDualOrchestration,
  isCmoePrimaryOrchestration,
} from "./cmoeOrchestrationMode";

function envFlag(name) {
  const v = process.env[name];
  return v === "1" || v === "true" || v === "TRUE";
}

/** Master switch for CMOE code paths */
export function isCmoeEnabled() {
  return envFlag("REACT_APP_CMOE_ENABLED");
}

function cmoeDataPlaneActive() {
  if (!isCmoeEnabled()) return false;
  return isCmoeDualOrchestration() || isCmoePrimaryOrchestration();
}

/** Command API — primary orchestration only */
export function isCmoeCommandApiEnabled() {
  return isCmoeEnabled() && isCmoePrimaryOrchestration();
}

/** Activity module — dual-write (dual) and primary cutover */
export function isCmoeActivityModuleEnabled() {
  return cmoeDataPlaneActive();
}

export function isCmoeProjectionsEnabled() {
  return cmoeDataPlaneActive();
}

export function isCmoeAllocationLedgerEnabled() {
  return cmoeDataPlaneActive();
}

/** Extra parity reads after dual-write (Phase 2.5 shadow mode). Default OFF. */
export function isCmoeShadowValidationEnabled() {
  return isCmoeEnabled() && envFlag("REACT_APP_CMOE_SHADOW_VALIDATION");
}

export const CMOE_FEATURE_FLAGS = {
  CMOE_ENABLED: "REACT_APP_CMOE_ENABLED",
  CMOE_ORCHESTRATION_MODE: "REACT_APP_CMOE_ORCHESTRATION_MODE",
  CMOE_SHADOW_VALIDATION: "REACT_APP_CMOE_SHADOW_VALIDATION",
};
